import CryptoJS from "crypto-js";
import axios from "axios";
import { store } from "../store/store";
import { toast } from "react-toastify";
import { isObject } from "formik";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  console.log('snviosevsv', config)
  config.url = encrypt(config.url);

  const data = config.data;

  let modifiedBody;
  if (data instanceof File || data instanceof FormData) {
    // Do not encrypt if body is a file or FormData
    modifiedBody = data;
  } else if (data) {
    // Encrypt body if it exists and is not a file/FormData
    console.log("snviosevsve", data);
    modifiedBody = { encryptedData: encrypt(JSON.stringify(data)) };
  }
  config.data = modifiedBody;
  const state = store.getState();
  const token = state.auth?.auth?.token; // adjust path based on your state shape

  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  config.headers["platform"] = "web";

  // if (
  //   config.method === "post" ||
  //   config.method === "put" ||
  //   config.method === "patch"
  // ) {
  //   if (typeof config.data === "object" && config.data !== null) {
  //     config.data = {
  //       ...config.data,
  //       device_info: {
  //         platform: "web",
  //       },
  //     };
  //   }
  // }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (!isObject(response.data?.data) && response.data?.data) {
      let decrptedData = decrypt(response.data?.data);
      response.data.data = JSON.parse(decrptedData);
    }
    if (response?.status == 400 && response.data.data && !isObject(response.data.data)) {
      try {
        const decryptedData = decrypt(response.data.data);
        response.data.data = JSON.parse(decryptedData);
      } catch (error) {
        console.error("Error decrypting resp.error.data:", error);
      }
    }
    // Return successful response
    if (response?.data?.message && response?.data?.message != 200 && response?.config?.method !== "get")
      toast.success(response.data.message);
    return Promise.resolve(response);
  },
  (error) => {
    const message =
      error.response?.data?.message || error.message || "Something went wrong!";
    toast.error(message);
    return Promise.reject(error);
  }
);

const SECRET_KEY = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_S_KEY); // 32-byte key
const SECRET_KEY_1 = "my_secret_key_123"; // Use a secure key
const IV = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV); // 16-byte IV

function toBase64Url(b64) {
  return b64
    .replace(/\+/g, "-") // '+' → '-'
    .replace(/\//g, "_") // '/' → '_'
    .replace(/=+$/, ""); // strip trailing '='
}

// Helper: Base64-URL → Standard Base64
function fromBase64Url(b64url) {
  let b64 = b64url
    .replace(/-/g, "+") // '-' → '+'
    .replace(/_/g, "/"); // '_' → '/'
  while (b64.length % 4) {
    b64 += "="; // restore padding
  }
  return b64;
}

function encrypt(data) {
  const cipher = CryptoJS.AES.encrypt(data, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7, // PKCS#7 padding :contentReference[oaicite:5]{index=5}
  });
  const b64 = cipher.toString(); // standard Base64
  return toBase64Url(b64); // convert to URL-safe form
}

function decrypt(b64url) {
  const b64 = fromBase64Url(b64url);
  // Build a CipherParams with the Base64-decoded ciphertext
  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Base64.parse(b64),
  });
  const bytes = CryptoJS.AES.decrypt(cipherParams, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return bytes.toString(CryptoJS.enc.Utf8);
}

export const apiCaller = async ({
  method = "GET", // GET, POST, PUT, DELETE
  url = "", // endpoint string
  params = {}, // query params
  data = {}, // request body
  headers = {}, // optional custom headers
}) => {
  try {
    // const encryptedUrl = encrypt(url);

    // Check if the body is a file or FormData
    const response = await axiosInstance({
      method: method.toLowerCase(),
      url,
      params, // goes in query string for GET
      data, // goes in body for POST, PUT
      headers,
    });
    console.log("snvusievbsev55", response);
    return response;
  } catch (error) {
    // Let global interceptor handle error
    console.log("snvusievbsev66", error);
    throw error;
    return error;
    // toast.error("Network Error");
  }
};

export default axiosInstance;
